// Module
var code = `<div class="show-standalone-lesson"><front-royal-spinner ng-if="!playerViewModel" class="fixed"></front-royal-spinner><show-lesson player-view-model="::playerViewModel" ng-if="::playerViewModel"></show-lesson></div>`;
// Exports
export default code;